import { Observable } from 'rxjs';
import { ProgramModel } from '../../models';

export abstract class BaseApiService {
  public abstract jsonApiRequest(pathOrNid: string, include?: string[]): Observable<any>;
}
